import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";
import { CreateGroupRequest } from "../../generated/core-api";

export function useCreateUserGroup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateGroupRequest) => api.createUserGroup(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user-groups"] });
    },
  });
}
